export default __webpack_public_path__ + "static/media/SomethingsWrong-Master11.75a19339.mp3";